/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'slots-by-video-private': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M15.51 10.68l-3.352 1.884v-.608c0-.519-.21-1.016-.586-1.383A2.023 2.023 0 0010.158 10H2c-.53 0-1.04.206-1.414.573A1.934 1.934 0 000 11.956v6.088c0 .519.21 1.016.586 1.383C.96 19.794 1.47 20 2 20h8.158c.53 0 1.04-.206 1.414-.573.376-.367.586-.864.586-1.383v-.608l3.352 1.884c.635.357 1.157.064 1.157-.651v-7.334c0-.719-.52-1.012-1.157-.655zm-3.12-1.672h7.193a.4.4 0 00.402-.402V4.413a.4.4 0 00-.402-.402h-.618V3.003A2.992 2.992 0 0015.976.015a2.992 2.992 0 00-2.988 2.988v1.008h-.598a.4.4 0 00-.402.402V8.61a.4.4 0 00.402.398zm2.598-6.005a.989.989 0 011.977 0v1.008h-1.98V3.003h.003z" _fill="#213F6B" fill-rule="nonzero"/>'
  }
})
